import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';

import DatePicker from "react-date-picker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getCities } from "../../../redux/actions/countryCityActions";
import CountryStateCity from '../../../components/countryStateCity/CountryStateCity';
import {updateCityPassword, getCityPasswordDetail} from '../../../redux/actions/citypasswordActions';
import NumberFormat from "react-number-format";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { createBrowserHistory } from "history";
const history = createBrowserHistory();

let isLoading = "false";
class EditCityPassword extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){
    super(props);
    this.state = {
      path: ["Home", "Manage City Passwords", "Update"],
      links:["home", "/city-password", "/city-password/edit"],
      password: "",
      description: "",
      start_date:"",
      end_date: "",
      city_ids:[],
      status: "active",
      cityerror:'false',
      show: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);

  	this.handleDismiss = this.handleDismiss.bind(this);
  	this.handleShow = this.handleShow.bind(this);
  }

 onChangeStartDate = date => { this.setState({ start_date: date})};
 onChangeEndDate = date => { this.setState({ end_date: date})};

	handleDismiss() {
		this.setState({ messageShow: false });
	}

	handleShow() {
		this.setState({ messageShow: true });
	}

  handleChange = (e) => {
  	if(`${e.target.name}Error` !== ''){
      this.setState({[`${e.target.name}Error`]:''})
    }
    if (e.target.name === "start_date" || e.target.name === "end_date") {
      this.setState({ endDateTimeError: "", startDateTimeError: "" });
    }
  	this.setState({[e.target.name]: e.target.value});
  }

    handleListChange(e) {
    let options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({
      [e.target.name]: value,
      cityMessage: ""
    });
  }

  componentWillMount(){
    isLoading = "true";
    this.props.clearAlert();
    this.props.getCities({page: 0});
    this.handleDismiss();
    if(this.props.match.params && this.props.match.params.citypasswordID){
      this.props.getCityPasswordDetail(this.props.match.params.citypasswordID);
    }
  }

  getValidationSDateState() {
    const sDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const eDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.start_date && this.state.start_date) {
      if (sDate > eDate) return "error";
    }
    if (!this.state.start_date && this.state.end_date) return "error";

    return null;
  }

  getValidationEDateState() {
    const sDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const eDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.end_date && this.state.start_date) {
      if (eDate < sDate) return "error";
    }
    if (!this.state.end_date && this.state.start_date) return "error";

    return null;
  }


  componentWillReceiveProps(nextProps){
  	if(this.props.citypasswordResponse !== nextProps.citypasswordResponse){
  		if(nextProps.citypasswordResponse){
  		  this.props.clearAlert();
          this.handleShow();
          if(nextProps.citypasswordResponse.response == 'success'){
            this.props.renderAlert("success", nextProps.citypasswordResponse.message);
          }else{
            this.props.renderAlert("danger", nextProps.citypasswordResponse.message);
          }
          window.scrollTo(0, 0);
          isLoading = "false";
  		}
  	}
    if(this.props.detail !== nextProps.detail){
      if(nextProps.detail){
        this.setState({
          id : nextProps.detail.data.cityPasswordID,
          password: nextProps.detail.data.password,
          description : nextProps.detail.data.description,
          start_date: (nextProps.detail.data.start_date) ? new Date(moment(nextProps.detail.data.start_date).format('YYYY-MM-DD')) : "",
          end_date: (nextProps.detail.data.end_date) ? new Date(moment(nextProps.detail.data.end_date).format('YYYY-MM-DD')) : "",
          city_ids: nextProps.detail.data.city_ids,
          status: nextProps.detail.data.status,
        });
        isLoading = "false";
      }
    }
  	if (this.props.error !== nextProps.error) {
	    if (nextProps.error) {
	      this.props.clearAlert();
	      this.handleShow();
	      this.props.renderAlert("danger", nextProps.error);
	      window.scrollTo(0, 0);
	      isLoading = "false";
	    }
	}
  if (this.props.cities !== nextProps.cities) {
    if (nextProps.cities) {
      this.setState({ citieslist: nextProps.cities });
    }
  }
	if (nextProps.message) {
		this.handleShow();
		this.setState({
		  alertMessage: nextProps.message,
		  msgType: nextProps.alertType
		});
	}
  }

  validate = (e) => {
    let isError = false;

    if(!this.state.password){
      isError = true;
      this.setState({passwordError:"red"})
    }

    if(!this.state.description){
      isError = true;
      this.setState({descriptionError:"red"})
    }

    if(!this.state.start_date){
      isError = true;
      this.setState({start_dateError:"red"})
    }

    if(!this.state.end_date){
      isError = true;
      this.setState({end_dateerror:"true"})
    }
   
    if(!this.state.city_ids){
      isError = true;
      this.setState({city_idserror:"true"})
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    if(!isError){
    	isLoading = "true";
		const constData = {
        id: this.state.id,
        password: this.state.password,
		    description: this.state.description,
	      start_date:this.state.start_date? moment(this.state.start_date).format("YYYY-MM-DD")
      : null,
        end_date: this.state.end_date? moment(this.state.end_date).format("YYYY-MM-DD")
      : null,
	      city_ids: this.state.city_ids,
	      status: "active",
		}
		this.props.updateCityPassword(constData);
    }
  }

  onStartDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const endDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.endDateTime && this.state.start_date) {
      if (startDate > endDate) {
        this.setState({
          startDateTimeError: "Start date should be less than end date!"
        });
      }else{
        this.setState({
          startDateTimeError: ""
        });
      }
    }
  };
  onEndDateTimeBlur = e => {
    e.preventDefault();
    const startDate = moment(this.state.start_date).format("YYYY-MM-DD");
    const endDate = moment(this.state.end_date).format("YYYY-MM-DD");
    if (this.state.start_date && this.state.end_date) {
      if (startDate > endDate) {
        this.setState({
          endDateTimeError: "End date should be greater than start date!"
        });
      }else{
       this.setState({
        endDateTimeError: ""
      });
     }
   }
 };

  render() {
    let citieslistData = this.state.citieslist ? this.state.citieslist : [];
    let citylist = [];
    if (citieslistData) {
      citylist = citieslistData.map((el, idx) => (
        <option key={el.cityID} value={el.cityID}>
          {el.title}
        </option>
      ));
    }
    
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">Edit City Password</header>
          <div className="panel-body">
          {this.state.messageShow &&
          this.state.alertMessage !== "" && (
            <div className="col-lg-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>Message:</strong>{" "}
                {this.state.alertMessage}
              </Alert>
            </div>
          )}
          <Row>
              <Col md={6} xs={12}>
                  <Row>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Password:</ControlLabel>
                        <FormControl
                          type="text"
                          placeholder="Password"
                          value={this.state.password}
                          name="password"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.passwordError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> Description:</ControlLabel>
                        <FormControl
                          type="textarea"
                          placeholder="Description"
                          value={this.state.description}
                          name="description"
                          onChange={this.handleChange}
                          style={{borderColor:this.state.descriptionError}}
                        />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                        <FormGroup
                        controlId="formStartDateTime"
                        validationState={this.getValidationSDateState()}
                        onBlur={this.onStartDateTimeBlur.bind(this)}
                        >
                        <ControlLabel><span style={{color: "red"}}>*</span> Start Date:</ControlLabel><br/>
                        <DatePicker            
                          onChange={this.onChangeStartDate} 
                          value={(this.state.start_date) ? this.state.start_date : "" }                                                  
                        />
                        {this.state.startDateTimeError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.startDateTimeError}
                          </Tooltip>
                        )}
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                      	<FormGroup
                        controlId="formEndDateTime"
                        validationState={this.getValidationEDateState()}
                        onBlur={this.onEndDateTimeBlur.bind(this)}
                        >
                        <ControlLabel><span style={{color: "red"}}>*</span> End Date:</ControlLabel><br/>
                         <DatePicker            
                          onChange={this.onChangeEndDate} 
                          value={(this.state.end_date) ? this.state.end_date : "" }                                                  
                        />    
                        {this.state.endDateTimeError && (
                          <Tooltip
                            placement="bottom"
                            className="in"
                            id="tooltip-bottom"
                          >
                            {this.state.endDateTimeError}
                          </Tooltip>
                        )}                   
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={126}>
                        <FormGroup>
                        <ControlLabel><span style={{color: "red"}}>*</span> City IDS :</ControlLabel>
                        <FormControl
                          name="city_ids"
                          componentClass="select"
                          onChange={this.handleListChange.bind(this)}
                          value={this.state.city_ids}
                          multiple
                        >
                          <option value="select">select (multiple)</option>

                          {citylist}
                        </FormControl>
                      </FormGroup>
                      </Col>
                  </Row>
              </Col>
          </Row>
          <Row>
          <hr/>
          </Row>
          <Row>
            <Col md={12} xs={12}>
            	<Button bsStyle="default" className="pull-right" onClick={() => this.context.router.history.push('/city-password')}>Cancel</Button>
              	<Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Save</Button>
            </Col>
          </Row>
          </div>
      </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.citypasswordReducer.error,
      cities: state.countryCityReducers.activecities,
      citypasswordResponse:  state.citypasswordReducer.citypasswordResponse,
      detail:  state.citypasswordReducer.detail,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {updateCityPassword, renderAlert, clearAlert, getCityPasswordDetail, getCities})
)(EditCityPassword);


// WEBPACK FOOTER //
// ./src/app/views/admin/citypassword/EditCityPassword.js